import get from 'lodash/get';
import flatten from 'lodash/flatten';

function getInputActionNodes(node, nodeMap, alreadyVisitedNodes = []) {
  // Prevent loops in case logic from triggering
  // an infinite call stack
  if (alreadyVisitedNodes.includes(node)) {
    return [];
  }
  if (node.name === 'Action') {
    return [node];
  } else {
    const connections = get(node, 'inputs.inputs.connections', []);
    return flatten(
      connections.map((connection) => {
        const inputNode = nodeMap[connection.node];
        return getInputActionNodes(inputNode, nodeMap, alreadyVisitedNodes.concat(node));
      })
    );
  }
}

export default getInputActionNodes;
